<template>
  <div>
    <template v-if="!hide">
      <!-- <span v-if="auth && auth.canEdit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="info"
              v-on="on"
              @click.stop="goTo(`/dictamenes/${params.data.uuid}`)"
              >mdi-eye-outline</v-icon
            >
          </template>
          <span>Ver</span>
        </v-tooltip>
      </span> -->
    
      <span v-if="auth && auth.canDelete">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="error"
              v-on="on"
              @click.stop="confirmDelete = true"
              >mdi-delete-outline</v-icon
            >
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </span>
    </template>

    <!-- Confirmación -->

    <confirmation
      v-model="confirmDelete"
      :text="'¿Eliminar dictamen?'"
      colorButton="error"
      @confirm="deleteItem()" />

  </div>
</template>

<script>
import Confirmation from '~/components/Confirmation'
export default {
  components: {
    Confirmation,
  },
  data: function () {
    return {
      confirmDelete: false,
      auth: {},
    }
  },
  computed: {
    isAprobada() {
      return this.params.data.estado === 'APROBADA'
    },

    IS_LIST() {
      return !this.$route.params.uuid
    },
    CAN_EDIT() {
      return this.IS_LIST ? this.$store.state.permisos.can_edit : true
    },
    CAN_DELETE() {
      return this.IS_LIST ? this.$store.state.permisos.can_delete : true
    },
    isNotGroup() {
      return !!this.params.data
    },
    hide() {
      return this.params.value === true
    },
  },
  methods: {
    init() {
      if (this.params.init instanceof Function) this.params.init()
    },
    goTo(path) {
      this.$router.push(path)
    },
  
    async deleteItem() {
      this.confirmDelete = false
      let gridOptions = this.$parent.gridOptions
      let gridApi = this.$parent.gridOptions.api
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`dictamenes/delete`, this.params.node.data)
        this.init()
      }
    },

    async checkRoles() {
      this.auth = await this.$store.dispatch('user/can', {
        module: 'dictamenes',
        submodule: 'dictamenes',
        return: 'all',
      })
      console.log('auth', this.auth)
    },
  },

  async mounted() {
    this.checkRoles()
  },
}
</script>
